var IconButton                        = require("app/ui/IconButton"),
    ChangeIsAdultForm                 = require("./ChangeIsAdultForm"),
    ChangeIsAdultLoginRequiredMessage = require("./ChangeIsAdultLoginRequiredMessage"),
    ChangeIsAdultSuccessMessage       = require("./ChangeIsAdultSuccessMessage"),
    frameThrottle                     = require("enyo-perf/utils").frameThrottle,
    icons                             = require("app/theme/icons"),
    kind                              = require("enyo/kind");

require("app/theme/IconButton--neutral.less");

module.exports = kind(/** @lends  app.ProfilePage.ChangeIsAdultButton.prototype */ {

    /**
     * @private
     */
    name: "app.ProfilePage.ChangeIsAdultButton",

    /**
     * @private
     */
    kind: IconButton,

    /**
     * @private
     */
    classes: "app-profile-page-change-is-adult-button",

    /**
     * The theme to use for this button.
     *
     * @type  {?string}
     * @public
     */
    theme: "neutral",

    /**
     * The id used to reference an icon from the icon-sprite.
     *
     * @type  {?string}
     * @public
     */
    icon: icons["app.ProfilePage.ChangeIsAdultButton"],

    /**
     * Align the icon on the left or the right.
     *
     * @type  {?string}
     * @public
     */
    iconAlignment: "left",

    /**
     * @private
     */
    handlers: {
        ontap: "ontap"
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.authService.isLoggedIn", this.update);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var authService = this.app.$.authService,
            i18nService = this.app.$.i18nService;

        this.set("caption", i18nService.getString("app.ProfilePage.ChangeIsAdultButton.caption"));
        this.set("tooltip", i18nService.getString("app.ProfilePage.ChangeIsAdultButton.tooltip"));

        if (authService.isLoggedIn === 1) {
            this.show();
        }
        else {
            this.hide();
        }
    },

    /**
     * Since taps could be bubbled from a popup owned by this control, we want
     * to verify the tap event's origin before handling it.
     *
     * @param  {enyo.Control}  sender  The sender
     * @param  {Object}        event   The event
     * @private
     */
    ontap: function(sender, event) {
        var node = this.hasNode();

        if (node && node.contains(event.target)) {
            this.showChangeIsAdultForm();
        }
    },

    /**
     * Reveals a popup with the change email form.
     *
     * @private
     */
    showChangeIsAdultForm: function() {
        var message;

        message = this.createComponent({
            kind:  ChangeIsAdultForm,
            state: this.state || {}
        });
        message.render();
        message.requestShow(true, false);
        message.on("hidden", function() {
            message.destroy();
        });
        message.on("login_required", this.bindSafely(function() {
            this.showChangeIsAdultLoginRequiredMessage();
        }));
        message.on("success", this.bindSafely(function() {
            this.showChangeIsAdultSuccessMessage();
        }));
    },

    /**
     * Reveals a popup with the success message.
     *
     * @private
     */
    showChangeIsAdultLoginRequiredMessage: function() {
        var message;

        message = this.createComponent({
            kind: ChangeIsAdultLoginRequiredMessage
        });
        message.render();
        message.requestShow(true, false);
        message.on("hidden", function() {
            message.destroy();
        });
    },

    /**
     * Reveals a popup with the success message.
     *
     * @private
     */
    showChangeIsAdultSuccessMessage: function() {
        var message;

        message = this.createComponent({
            kind: ChangeIsAdultSuccessMessage
        });
        message.render();
        message.requestShow(true, false);
        message.on("hidden", function() {
            message.destroy();
        });
    }

});
